var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PostalCodeEdit", {
        attrs: { meta: _vm.meta },
        on: { input: _vm.emitChangeEvent },
        model: {
          value: _vm.postalCode,
          callback: function($$v) {
            _vm.postalCode = $$v
          },
          expression: "postalCode"
        }
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            { attrs: { md: "5" } },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    label: "Straße",
                    state: _vm.streetValid,
                    "invalid-feedback": "Bitte gib die Straße ein",
                    "feedback-beneath": ""
                  }
                },
                [
                  _c("b-input", {
                    on: { input: _vm.emitChangeEvent },
                    model: {
                      value: _vm.street,
                      callback: function($$v) {
                        _vm.street = $$v
                      },
                      expression: "street"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "2" } },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    label: "Hausnummer",
                    state: _vm.streetNumberValid,
                    "invalid-feedback": "Bitte gib die Hausnummer ein",
                    "feedback-beneath": ""
                  }
                },
                [
                  _c("b-input", {
                    on: { input: _vm.emitChangeEvent },
                    model: {
                      value: _vm.streetNumber,
                      callback: function($$v) {
                        _vm.streetNumber = $$v
                      },
                      expression: "streetNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "5" } },
            [
              _c(
                "FormGroup",
                {
                  attrs: {
                    label: "Nähere Angaben zum Ort",
                    description: "z.B. Name des Restaurants, ..."
                  }
                },
                [
                  _c("b-input", {
                    on: { input: _vm.emitChangeEvent },
                    model: {
                      value: _vm.extraInfo,
                      callback: function($$v) {
                        _vm.extraInfo = $$v
                      },
                      expression: "extraInfo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }